import { render, staticRenderFns } from "./UserRefund.vue?vue&type=template&id=70f25101&scoped=true&"
import script from "./UserRefund.vue?vue&type=script&lang=js&"
export * from "./UserRefund.vue?vue&type=script&lang=js&"
import style0 from "./UserRefund.vue?vue&type=style&index=0&id=70f25101&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f25101",
  null
  
)

export default component.exports